import { normalizeSort } from '../utils'
import MovimientoService from '../services/MovimientoService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['created_at'],
    sortDesc: [true]
  }
})

const getters = {
  MOVIMIENTOS: state => {
    return state.list
  },
  MOVIMIENTOS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_MOVIMIENTOS: (state, payload) => {
    state.list = payload
  },
  SET_MOVIMIENTOS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_MOVIMIENTO: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_MOVIMIENTO: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_MOVIMIENTO: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_MOVIMIENTO: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_MOVIMIENTOS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }
      let { data, status } = await MovimientoService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        commit('SET_MOVIMIENTOS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de movimiento')
      console.error(error)
    }
  },
  VIEW_MOVIMIENTO: async (obj, params) => {
    try {
      let { data, status } = await MovimientoService.view(params)
      if (status === 200) {
        return data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles de los movimiento')
    }
  },
  ADD_MOVIMIENTO: async ({ commit }, payload) => {
    try {
      let { data, status } = await MovimientoService.post(payload)
      if (status === 201) {
        commit('ADD_MOVIMIENTO', data)
        window.app.$toast.success('El movimiento ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_MOVIMIENTO: async ({ commit }, payload) => {
    try {
      let { data, status } = await MovimientoService.put(payload)
      if (status === 200) {
        commit('UPDATE_MOVIMIENTO', data)
        window.app.$toast.success('El movimiento ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_MOVIMIENTO: async ({ commit }, payload) => {
    try {
      let { status } = await MovimientoService.delete(payload)
      if (status === 204) {
        commit('DELETE_MOVIMIENTO', payload)
        window.app.$toast.success('El movimiento ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el movimiento')
    }
  },
  SCAN_PLATE_NUMBER: async ({ commit }, payload) => {
    try {
      let { data, status } = await MovimientoService.scanPlateNumber(payload)
      if (status === 200) {
        window.app.$toast.success('El número de placa ha sido escaneado satisfactoriamente')
        return data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar escanear el número de placa')
      return { error: true, data: error.response.data, status: error.response.status }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
